import React from 'react';
import styles from './css/index.module.scss';

function About() {
  return (
    <div className={styles.aboutWrapper}>
      <h1 id="dev_page_title">How does Fragment work?</h1>

      <div id="dev_page_content">
        <p>
          <a href="/">Fragment</a>
          {' '}
          is a
          {' '}
          {' '}
          <strong>free platform</strong>
          {' '}
          which facilitates the transaction of collectibles between users and the purchase of services from third parties. It supports direct,
          {' '}
          {' '}
          <strong>secure</strong>
          {' '}
          and
          {' '}
          {' '}
          <strong>anonymous</strong>
          {' '}
          sales as well as
          {' '}
          {' '}
          <strong>public auctions</strong>
          {' '}
          where everyone can participate over a period of time.
          <br />
          Fragment also facilitates your engagement with certain third party services, like purchasing Telegram Premium, Telegram Ads or the withdrawal of
          {' '}
          {' '}
          <a href="https://telegram.org/blog/monetization-for-channels">content creator rewards</a>
          .
        </p>
        <p>
          To provide these services transparently, Fragment takes full advantage of
          {' '}
          <a href="https://en.wikipedia.org/wiki/Telegram_Open_Network">TON</a>
          , a blockchain technology initially developed by Telegram.
          {' '}
        </p>
        <p>
          If you have used similar platforms before, go ahead and connect your Telegram account and your
          {' '}
          <a href="https://ton.org/wallets">TON wallet</a>
          {' '}
          to
          {' '}
          <a href="/">Fragment</a>
          , then open the relevant tab on our
          {' '}
          <a href="/">homepage</a>
          {' '}
          and proceed with your bid or purchase. If you are not familiar with these terms and don't know where to start, simply follow the handy
          {' '}
          <a href="#how-to-pay">tutorial</a>
          {' '}
          available below.
        </p>
        <h2>
          <a className="anchor-link" href="#index"><i className="anchor-icon" /></a>
          <a className="anchor" name="index" />
          Index
        </h2>
        <ul>
          <li>
            {' '}
            <a href="#how-to-pay">How to Pay?</a>
          </li>
          <li>
            {' '}
            <a href="#telegram-ads">Telegram Ads</a>
          </li>
          <li>
            {' '}
            <a href="#telegram-stars">Telegram Stars</a>
          </li>
          <li>
            {' '}
            <a href="#telegram-premium">Telegram Premium</a>
          </li>
          <li>
            {' '}
            <a href="#anonymous-numbers">Anonymous Numbers</a>
          </li>
          <li>
            {' '}
            <a href="#collectible-usernames">Collectible Usernames</a>
          </li>
          <li>
            {' '}
            <a href="#auctions-and-sales-of-collectibles">Auctions and Sales</a>
          </li>
        </ul>
        <h2>
          <a className="anchor-link" href="#how-to-pay"><i className="anchor-icon" /></a>
          <a className="anchor" name="how-to-pay" />
          How to Pay?
        </h2>
        <p>
          Fragment relies on
          {' '}
          <a href="https://en.wikipedia.org/wiki/Telegram_Open_Network">TON</a>
          {' '}
          blockchain technology for fast, secure and anonymous transactions, allowing you to exchange Toncoins for goods and services.
          {' '}
        </p>
        <p>
          To make payments with Toncoin, you will need to
          {' '}
          <a href="#creating-a-wallet">set up a wallet</a>
          {' '}
          – think of it as an app that holds your funds and lets you interact with other users and apps on the TON blockchain, including Fragment. Once your wallet is set up, it can hold the
          {' '}
          <a href="#depositing-funds">Toncoin you purchase</a>
          , ready for you to spend on Fragment and similar exchanges.
        </p>
        <h3>
          <a className="anchor-link" href="#creating-a-wallet"><i className="anchor-icon" /></a>
          <a className="anchor" name="creating-a-wallet" />
          Creating a Wallet
        </h3>
        <p>
          Creating a wallet is very
          {' '}
          <strong>straightforward</strong>
          {' '}
          and will only take a couple minutes. First, install a TON Wallet such as
          {' '}
          <a href="https://tonkeeper.com/">TonKeeper</a>
          {' '}
          or
          {' '}
          <a href="https://mytonwallet.io/">MyTonWallet</a>
          {' '}
          (more wallets are listed
          {' '}
          <a href="https://ton.org/wallets">here</a>
          ).
        </p>
        <p>
          You will be presented with a numbered list of words – this is the equivalent of your
          {' '}
          <strong>password</strong>
          {' '}
          and you
          {' '}
          <strong>must</strong>
          {' '}
          write it down or store it securely. Failure to do so
          {' '}
          <strong>will</strong>
          {' '}
          result in the irreversible loss of your wallet, funds and collectibles.
        </p>
        <blockquote>
          <p>
            With non-custodial wallets like TonKeeper or MyTonWallet nobody holds the keys to your funds but you. While this is very secure, it also means that if you lose the keys nobody will be able to help you restore them; be sure to
            {' '}
            <strong>back up your credentials</strong>
            .
          </p>
        </blockquote>
        <h3>
          <a className="anchor-link" href="#depositing-funds"><i className="anchor-icon" /></a>
          <a className="anchor" name="depositing-funds" />
          Depositing Funds
        </h3>
        <p>
          Once your wallet is ready, you'll have to
          {' '}
          <strong>deposit funds</strong>
          {' '}
          in it. To deposit existing TON stored somewhere else (e.g. from a friend, family, etc.), open your wallet and look for a
          {' '}
          <strong>receive</strong>
          {' '}
          or
          {' '}
          <strong>deposit</strong>
          {' '}
          button, which should display a QR code – anyone can scan this code from their wallet app to send you funds.
        </p>
        <p>
          If you
          {' '}
          <strong>do not own</strong>
          {' '}
          any TON, you will need to buy it. A list of reputable platforms and exchanges which offer this service is available
          {' '}
          <a href="https://ton.org/buy-toncoin">here</a>
          ; some of them may ask for a form of identification – this is to be expected as you will be exchanging funds.
        </p>
        <p>
          No matter which platform you pick, be sure to insert
          {' '}
          <strong>your wallet address</strong>
          {' '}
          when you are prompted for one to deposit or withdraw your TON – if you don't insert the correct wallet address, your funds may be lost. For maximum safety, copy-paste your wallet address directly from the wallet app.
        </p>
        <blockquote>
          <p>
            Don't panic if your new funds don't appear immediately! Transactions usually happen within seconds, but may sometimes take longer. If you still don't see them after 30 minutes, check out the
            {' '}
            <a href="#faq">FAQ</a>
            {' '}
            section below.
          </p>
        </blockquote>
        <h3>
          <a className="anchor-link" href="#connecting-to-fragment-and-telegram"><i className="anchor-icon" /></a>
          <a className="anchor" name="connecting-to-fragment-and-telegram" />
          Connecting To Fragment and Telegram
        </h3>
        <p>
          Once your funds show up in your
          {' '}
          <strong>wallet</strong>
          , open
          {' '}
          <a href="/">Fragment</a>
          {' '}
          and use the “Connect TON” button in the top-right corner, then select your wallet and follow the instructions to continue.
        </p>
        <p>To use Fragment services related to Telegram, use the “Connect Telegram” widget – if you’re on mobile, you can find it by opening the burger menu in the top-right corner.</p>
        <blockquote>
          <p>
            Before you purchase, bid or interact with any services on Fragment, we recommend double checking that you
            {' '}
            <strong>connected the correct wallet</strong>
            {' '}
            – this includes making sure that you use the right wallet when prompted to scan additional QR codes to confirm transactions.
          </p>
        </blockquote>
        <h2>
          <a className="anchor-link" href="#telegram-ads"><i className="anchor-icon" /></a>
          <a className="anchor" name="telegram-ads" />
          Telegram Ads
        </h2>
        <p>
          The
          {' '}
          <a href="https://ads.telegram.org/">Telegram Ad Platform</a>
          {' '}
          allows advertisers to display ads on large public channels on Telegram. Eligible channel owners may receive a share of the revenue generated by ads displayed on their channels.
        </p>
        <p>Fragment enables the purchase of ads on Telegram and the withdrawal of rewards for eligible owners of channels where they are displayed.</p>
        <h3>
          <a className="anchor-link" href="#purchasing-ads"><i className="anchor-icon" /></a>
          <a className="anchor" name="purchasing-ads" />
          Purchasing Ads
        </h3>
        <p>
          To purchase Ads for your bot or channel, you will first need to log in to
          {' '}
          <a href="https://ads.telegram.org">ads.telegram.org</a>
          {' '}
          and create your ad account. To deposit funds, you can select
          {' '}
          <em>Budget &gt; Add Funds</em>
          , which may redirect you to Fragment to complete the transaction.
        </p>
        <p>
          If you haven’t already done so, you will need to
          {' '}
          <a href="#creating-a-wallet">connect your TON wallet</a>
          {' '}
          to Fragment. Then, simply enter the budget for your ad account in TON and tap
          {' '}
          <em>‘Add Funds’</em>
          .
        </p>
        <h3>
          <a className="anchor-link" href="#advertisement-revenue-sharing"><i className="anchor-icon" /></a>
          <a className="anchor" name="advertisement-revenue-sharing" />
          Advertisement Revenue Sharing
        </h3>
        <p>
          If you are the owner of a channel that participates in the Telegram
          {' '}
          <a href="https://telegram.org/blog/monetization-for-channels">advertisement revenue sharing</a>
          {' '}
          program, you can use Fragment to withdraw the rewards you’ve accrued.
        </p>
        <h2>
          <a className="anchor-link" href="#telegram-stars"><i className="anchor-icon" /></a>
          <a className="anchor" name="telegram-stars" />
          Telegram Stars
        </h2>
        <p>
          Bot developers and content creators who receive
          {' '}
          <a href="https://telegram.org/blog/telegram-stars">Telegram Stars</a>
          {' '}
          in exchange for digital products, services, content or other perks can use Fragment to obtain rewards.
        </p>
        <blockquote>
          <p>
            Your engagement with
            {' '}
            <a href="https://telegram.org/blog/telegram-stars">Telegram Stars</a>
            {' '}
            is  subject to Telegram’s
            {' '}
            <a href="https://telegram.org/tos/stars">Terms of Service for Stars</a>
            ,
            {' '}
            <a href="https://telegram.org/tos/bot-developers">Bot Developers</a>
            {' '}
            and
            {' '}
            <a href="https://telegram.org/tos/content-creator-rewards">Content Creators</a>
            .
          </p>
        </blockquote>
        <h2>
          <a className="anchor-link" href="#telegram-premium"><i className="anchor-icon" /></a>
          <a className="anchor" name="telegram-premium" />
          Telegram Premium
        </h2>
        <p>
          Fragment allows Telegram users to purchase subscriptions prepay for giveaways of Telegram Premium.
        </p>
        <h3>
          <a className="anchor-link" href="#buy-telegram-premium"><i className="anchor-icon" /></a>
          <a className="anchor" name="buy-telegram-premium" />
          Buy Telegram Premium
        </h3>
        <p>
          You can buy Telegram Premium for yourself or gift it to a friend by selecting
          {' '}
          <em>‘Buy Premium for a User’</em>
          {' '}
          from the Telegram Premium page on Fragment.
          {' '}
        </p>
        <h3>
          <a className="anchor-link" href="#premium-giveaways"><i className="anchor-icon" /></a>
          <a className="anchor" name="premium-giveaways" />
          Premium Giveaways
        </h3>
        <p>Channels or groups looking to give away Telegram Premium subscriptions to their members can use Fragment to pay for the giveaway in TON. </p>
        <h2>
          <a className="anchor-link" href="#anonymous-numbers"><i className="anchor-icon" /></a>
          <a className="anchor" name="anonymous-numbers" />
          Anonymous Numbers
        </h2>
        <p>
          In late 2022, Telegram released a limited run of
          {' '}
          <a href="/numbers">virtual phone numbers</a>
          {' '}
          as collectibles on the TON blockchain. Telegram users can use these numbers to
          {' '}
          <a href="https://telegram.org/blog/ultimate-privacy-topics-2-0#sign-up-without-a-sim-card">sign up without a SIM card</a>
          {' '}
          and receive their login codes directly on Fragment, rather than via SMS.
        </p>
        <h3>
          <a className="anchor-link" href="#obtaining-an-anonymous-number"><i className="anchor-icon" /></a>
          <a className="anchor" name="obtaining-an-anonymous-number" />
          Obtaining an Anonymous Number
        </h3>
        <p>
          Anonymous Numbers are a form of collectible – check out
          {' '}
          <a href="#what-is-a-collectible">this section</a>
          {' '}
          below to learn what a collectible is and how to purchase them. If you already own an anonymous number, you can add and remove it from your Telegram account at will – and list it for auction or sale on Fragment.
        </p>
        <blockquote>
          <p>The direct sale of anonymous numbers ended in 2022 – currently, the only way to acquire an anonymous number is to purchase it from another user on Fragment.</p>
        </blockquote>
        <h3>
          <a className="anchor-link" href="#creating-a-telegram-account-with-an-anonymous-number"><i className="anchor-icon" /></a>
          <a className="anchor" name="creating-a-telegram-account-with-an-anonymous-number" />
          Creating a Telegram Account with an Anonymous Number
        </h3>
        <p>
          Once you obtain an Anonymous Number, simply open your Telegram app and sign up by entering your number in the relevant text field. When prompted for an OTP,
          {' '}
          <a href="#connecting-to-fragment-and-telegram">connect your wallet</a>
          {' '}
          to Fragment and navigate to
          {' '}
          <a href="/numbers">this page</a>
          {' '}
          to receive your login code.
        </p>
        <blockquote>
          <p>Note that these Anonymous Numbers only work on Telegram – you cannot use them to call, send SMS or sign up to other services, unless such services choose to support them.</p>
        </blockquote>
        <h3>
          <a className="anchor-link" href="#switching-to-an-anonymous-number-on-telegram"><i className="anchor-icon" /></a>
          <a className="anchor" name="switching-to-an-anonymous-number-on-telegram" />
          Switching to an Anonymous Number on Telegram
        </h3>
        <p>
          Telegram users can update the phone number connected to their at any time from the Settings page of their Telegram
          {' '}
          <a href="https://telegram.org/apps#mobile-apps">mobile app</a>
          . To switch to an anonymous number, simply enter the +888 number you’ve acquired, and when prompted for an OTP, check
          {' '}
          <a href="/numbers">this page</a>
          {' '}
          on Fragment to receive your login code.
        </p>
        <h2>
          <a className="anchor-link" href="#collectible-usernames"><i className="anchor-icon" /></a>
          <a className="anchor" name="collectible-usernames" />
          Collectible Usernames
        </h2>
        <p>
          Fragment supports the sale and exchange of
          {' '}
          <a href="https://telegram.org">Telegram</a>
          {' '}
          usernames – giving users the ability to securely acquire and sell catchy
          {' '}
          <a href="#what-is-a-collectible">collectible</a>
          {' '}
          usernames, as well as
          {' '}
          <a href="#auctioning-basic-usernames">convert existing usernames</a>
          {' '}
          on Telegram into collectibles.
          {' '}
        </p>
        <h3>
          <a className="anchor-link" href="#obtaining-a-collectible-username"><i className="anchor-icon" /></a>
          <a className="anchor" name="obtaining-a-collectible-username" />
          Obtaining a Collectible Username
        </h3>
        <p>
          You can acquire a collectible username through direct sales or
          {' '}
          <a href="#bidding-ton">open auctions</a>
          {' '}
          on Fragment. After completing a purchase or winning an auction, ownership of the username is transferred to the
          {' '}
          <strong>TON wallet</strong>
          {' '}
          you used to complete the purchase.
        </p>
        <blockquote>
          <p>
            If you already have an existing username on Telegram, you can
            {' '}
            <a href="#listing-your-username-on-fragment">convert it</a>
            {' '}
            to a collectible username to cement your ownership of it in the blockchain.
          </p>
        </blockquote>
        <h3>
          <a className="anchor-link" href="#using-your-new-collectible-username"><i className="anchor-icon" /></a>
          <a className="anchor" name="using-your-new-collectible-username" />
          Using your new collectible username
        </h3>
        <p>After receiving a collectible, you can:</p>
        <ul>
          <li>
            {' '}
            <a href="#assigning-collectible-usernames-to-telegram">Assign it on Telegram</a>
            . Any profile, group or channel can have
            {' '}
            {' '}
            <a href="https://telegram.org/blog/topics-in-groups-collectible-usernames#collectible-usernames">multiple collectible usernames</a>
            {' '}
            linking to it.
          </li>
          <li>
            {' '}
            <a href="#putting-collectibles-up-for-auction">Sell it or start a new auction</a>
            {' '}
            – without paying a
            {' '}
            {' '}
            <a href="#q-what-39s-the-conversion-fee">conversion fee</a>
            .
          </li>
          <li>
            Securely transfer it to another person or wallet
            {' '}
            <strong>for free</strong>
            {' '}
            via your wallet app.
          </li>
        </ul>
        <h3>
          <a className="anchor-link" href="#assigning-collectible-usernames-to-telegram"><i className="anchor-icon" /></a>
          <a className="anchor" name="assigning-collectible-usernames-to-telegram" />
          Assigning Collectible Usernames to Telegram
        </h3>
        <p>
          You can assign
          {' '}
          <strong>collectible usernames</strong>
          {' '}
          to your personal Telegram
          {' '}
          <strong>profile</strong>
          {' '}
          or to Telegram public
          {' '}
          <strong>groups</strong>
          {' '}
          and
          {' '}
          <strong>channels</strong>
          {' '}
          you own. Any of these entities can have up to
          {' '}
          <strong>one</strong>
          {' '}
          basic username and
          {' '}
          <strong>any number</strong>
          {' '}
          of collectible usernames – you can also customize the order in which collectibles appear in the chat's info page, or toggle them off entirely.
        </p>
        <blockquote>
          <p>
            You can also upgrade collectible usernames to assign them to
            {' '}
            <strong>Telegram bots</strong>
            . To upgrade, assign the username to a bot and pay a one-time fee.
          </p>
        </blockquote>
        <p>
          Note that before you can assign a username, you must connect both your
          {' '}
          <strong>Telegram account</strong>
          {' '}
          and
          {' '}
          <strong>TON wallet</strong>
          {' '}
          to Fragment. To do so, follow the instructions available
          {' '}
          <a href="#connecting-to-fragment-and-telegram">here</a>
          .
        </p>
        <p>
          The wallet you are connecting must be the one currently holding your collectible – if you don't see any items in your wallet please check our
          {' '}
          <a href="#q-i-won-an-auction-but-can-39t-see-the-collectible-in-my-assets">FAQ</a>
          .
        </p>
        <blockquote>
          <p>
            Fragment
            {' '}
            <strong>doesn't store</strong>
            {' '}
            any information that could tie your wallet to your Telegram account.
          </p>
        </blockquote>
        <h4>
          <a className="anchor-link" href="#assigning-your-collectible"><i className="anchor-icon" /></a>
          <a className="anchor" name="assigning-your-collectible" />
          Assigning your collectible
        </h4>
        <p>
          Open the
          {' '}
          <a href="/my/assets">My Assets</a>
          {' '}
          page and tap on '
          {' '}
          <em>Assign to Telegram</em>
          ', then select a chat and tap '
          {' '}
          <em>Assign</em>
          ' to confirm your choice.
        </p>
        <blockquote>
          <p>This choice is not permanent, you can pick another chat at any time.</p>
        </blockquote>
        <h4>
          <a className="anchor-link" href="#activating-your-collectible-on-telegram"><i className="anchor-icon" /></a>
          <a className="anchor" name="activating-your-collectible-on-telegram" />
          Activating your collectible on Telegram
        </h4>
        <p>
          Once your collectible has been assigned, it will not redirect to your designated chat right away. To activate and list it in the public info page of your chat, you have to
          {' '}
          <strong>manually enable it</strong>
          .
        </p>
        <p>To do so, follow these simple steps:</p>
        <ul>
          <li>
            <p>
              {' '}
              <strong>Personal Profile</strong>
              : Settings &gt; Username &gt; Enable and sort the available usernames as needed.
            </p>
          </li>
          <li>
            <p>
              {' '}
              <strong>Public Group</strong>
              : Open your group settings ( ⋮
              {' '}
              {' '}
              <em>Android</em>
              , '…'
              {' '}
              {' '}
              <em>iOS</em>
              {' '}
              ) &gt; Group Type &gt; '
              {' '}
              <em>Links order</em>
              ' &gt; Tap on your collectible to enable it.
            </p>
          </li>
          <li>
            <p>
              {' '}
              <strong>Public Channel</strong>
              : Open your channel settings ⋮
              {' '}
              {' '}
              <em>Android</em>
              , '…'
              {' '}
              {' '}
              <em>iOS</em>
              {' '}
              ) &gt; Channel Type &gt; '
              {' '}
              <em>Links order</em>
              ' &gt; Tap on your collectible to enable it.
            </p>
          </li>
        </ul>
        <blockquote>
          <p>Older Telegram clients may not show any username beyond the first on the info page of your chats.</p>
        </blockquote>
        <h2>
          <a className="anchor-link" href="#auctions-and-sales-of-collectibles"><i className="anchor-icon" /></a>
          <a className="anchor" name="auctions-and-sales-of-collectibles" />
          Auctions and Sales of Collectibles
        </h2>
        <h3>
          <a className="anchor-link" href="#what-is-a-collectible"><i className="anchor-icon" /></a>
          <a className="anchor" name="what-is-a-collectible" />
          What is a Collectible
        </h3>
        <p>
          A
          {' '}
          <strong>collectible</strong>
          {' '}
          is a unique item (e.g. a username, virtual phone number, etc.) that is
          {' '}
          <strong>permanently recorded</strong>
          {' '}
          on the public TON blockchain as property owned by the holder of the corresponding address. TON offers a free, distributed and secure interface for developers to integrate collectibles into their platforms.
        </p>
        <p>
          Once you obtain a collectible, it is yours
          {' '}
          <strong>forever</strong>
          {' '}
          and you are free to show it off, sell it, or take advantage of the features it unlocks. The unique functionalities tied to collectibles will depend on how each platform chooses to support them.
          {' '}
        </p>
        <blockquote>
          <p>Other services are free to integrate collectibles to unlock cross-platform, permanent perks for their users.</p>
        </blockquote>
        <h3>
          <a className="anchor-link" href="#how-can-i-purchase-collectibles"><i className="anchor-icon" /></a>
          <a className="anchor" name="how-can-i-purchase-collectibles" />
          How can I purchase collectibles?
        </h3>
        <p>
          You can purchase a collectible on
          {' '}
          <a href="/">Fragment</a>
          {' '}
          by exchanging it with a currency called
          {' '}
          <strong>Toncoin</strong>
          {' '}
          – the amount you need will depend on what the current highest bid is, just like any other auction.
        </p>
        <p>
          To use this currency you must first
          {' '}
          <a href="#creating-a-wallet">create a secure wallet</a>
          {' '}
          to store it,
          {' '}
          <a href="#depositing-funds">deposit new funds</a>
          {' '}
          in it and finally
          {' '}
          <a href="#connecting-to-fragment-and-telegram">connect it to Fragment</a>
          .
        </p>
        <blockquote>
          <p>
            If you're running into any issue while following this tutorial, check out the
            {' '}
            <a href="#faq">FAQ</a>
            {' '}
            section below.
          </p>
        </blockquote>
        <h4>
          <a className="anchor-link" href="#bidding-ton"><i className="anchor-icon" /></a>
          <a className="anchor" name="bidding-ton" />
          Bidding TON
        </h4>
        <p>
          After connecting to Fragment, you're all set and ready to bid on
          {' '}
          <strong>any available collectible</strong>
          . To do so, tap on one of the available auctions, enter an amount, confirm it and pay via your wallet – just like you did when you were connecting it to Fragment.
        </p>
        <p>During bidding, whoever’s bid is first to the blockchain will get the bid at that price. If your bid wasn’t reflected in the blockchain before the auction ends, you will get the money back and lose the bid. Likewise, if someone outbids you, your money will be returned to you.</p>
        <blockquote>
          <p>
            Usernames listed as
            {' '}
            <em>Taken</em>
            {' '}
            are currently in use and not available for sale. However, you can pay a
            {' '}
            <strong>small fee</strong>
            {' '}
            to
            {' '}
            <a href="#why-is-the-collectible-i-want-marked-as-unavailable">notify their owner</a>
            {' '}
            that you are interested in acquiring the name. To do so, search for the username on Fragment, open its page and tap on '
            {' '}
            <em>Make an offer</em>
            '.
          </p>
        </blockquote>
        <h3>
          <a className="anchor-link" href="#putting-collectibles-up-for-auction"><i className="anchor-icon" /></a>
          <a className="anchor" name="putting-collectibles-up-for-auction" />
          Putting Collectibles Up For Auction
        </h3>
        <p>
          If you own a collectible, you are free to either sell it directly or auction it to the public at any time. To do so, tap on
          {' '}
          <a href="/my/assets">My Assets</a>
          {' '}
          and select either
          {' '}
          <em>Put up for auction</em>
          {' '}
          or
          {' '}
          <em>Sell</em>
          {' '}
          depending on what you want to do.
        </p>
        <blockquote>
          <p>
            If you decide to auction one of your unique items (e.g., usernames, phone numbers, etc.), remember that you can set an optional
            {' '}
            <strong>maximum price</strong>
            {' '}
            which, if paid, will immediately end the auction. Note that collectibles are subject to a
            {' '}
            <strong>5% platform fee</strong>
            {' '}
            on each transaction.
          </p>
        </blockquote>
        <h4>
          <a className="anchor-link" href="#auctioning-basic-usernames"><i className="anchor-icon" /></a>
          <a className="anchor" name="auctioning-basic-usernames" />
          Auctioning Basic Usernames
        </h4>
        <p>
          Any basic username from your Telegram account can be
          {' '}
          <a href="#listing-your-username-on-fragment">auctioned on Fragment</a>
          , including those that are linked to your
          {' '}
          <strong>profile</strong>
          ,
          {' '}
          <strong>public groups</strong>
          {' '}
          or
          {' '}
          <strong>public channels</strong>
          .
        </p>
        <p>
          Interested buyers can
          {' '}
          <strong>place a bid</strong>
          {' '}
          to
          {' '}
          <strong>start an auction</strong>
          {' '}
          at any time –
          {' '}
          <a href="#when-the-auction-ends">when the auction ends</a>
          , the basic username will be
          {' '}
          <strong>converted</strong>
          {' '}
          into a collectible and assigned to the winner.
        </p>
        <p>
          The original owner of the basic username will
          {' '}
          <strong>earn</strong>
          {' '}
          all proceeds
          {' '}
          <a href="#q-are-there-any-transaction-fees">minus applicable fees</a>
          . They may also try to win the auction themselves to retain ownership of the new collectible.
        </p>
        <h4>
          <a className="anchor-link" href="#listing-your-username-on-fragment"><i className="anchor-icon" /></a>
          <a className="anchor" name="listing-your-username-on-fragment" />
          Listing your username on Fragment
        </h4>
        <p>
          If you own a
          {' '}
          <strong>basic username</strong>
          {' '}
          on
          {' '}
          <strong>Telegram</strong>
          {' '}
          and wish to make it available on Fragment, simply:
        </p>
        <ul>
          <li>
            {' '}
            <a href="#connecting-to-fragment-and-telegram">Log in</a>
            {' '}
            to Fragment with both your Telegram and TON accounts.
          </li>
          <li>The TON wallet you've connected will receive the proceeds from the auction, so make sure to connect a wallet that you own.</li>
          <li>
            Tap on your TON wallet in the top right corner and choose
            {' '}
            <a href="/convert">'Convert to Collectibles'</a>
            {' '}
            (or follow the 'Convert Usernames to Collectibles' link in 'My Assets').
          </li>
          <li>Select a username from the list. Note that to prevent abuse, usernames you acquired or reassigned (i.e., moved it from your profile to a channel you own, etc.) very recently may not be immediately available.</li>
          <li>Set a minimum bid. Buyers will have to pay at least this amount to acquire the collectible.</li>
        </ul>
        <p>
          After confirming, your username will remain available for auction for an
          {' '}
          <strong>unlimited time</strong>
          {' '}
          – interested buyers, including yourself, can
          {' '}
          <strong>place the first bid</strong>
          {' '}
          to start a
          {' '}
          <strong>7-day auction</strong>
          .
        </p>
        <blockquote>
          <p>
            While a username is available for auction, you can't
            {' '}
            <strong>reassign</strong>
            {' '}
            it to a
            {' '}
            <em>different</em>
            {' '}
            chat or profile (but you can
            {' '}
            <em>remove</em>
            {' '}
            it to protect privacy, or
            {' '}
            <strong>restore</strong>
            {' '}
            it in the same place). You can
            {' '}
            <a href="#canceling-an-auction">cancel</a>
            {' '}
            the auction to reassign the username elsewhere.
          </p>
        </blockquote>
        <h4>
          <a className="anchor-link" href="#canceling-an-auction"><i className="anchor-icon" /></a>
          <a className="anchor" name="canceling-an-auction" />
          Canceling an auction
        </h4>
        <p>
          You can cancel the auction at any time
          {' '}
          <strong>before the first bid</strong>
          {' '}
          is placed. If you do so, you will keep the basic username and it will
          {' '}
          <strong>not be converted</strong>
          {' '}
          into a collectible.
        </p>
        <p>After the first bid is placed, the auction can no longer be canceled.</p>
        <h4>
          <a className="anchor-link" href="#when-the-auction-ends"><i className="anchor-icon" /></a>
          <a className="anchor" name="when-the-auction-ends" />
          When the auction ends
        </h4>
        <p>
          When the auction
          {' '}
          <strong>ends</strong>
          {' '}
          you will
          {' '}
          <strong>earn</strong>
          {' '}
          all proceeds minus
          {' '}
          <a href="#q-are-there-any-transaction-fees">applicable fees</a>
          . The outcome may slightly differ depending on the winner:
        </p>
        <ul>
          <li>
            {' '}
            <strong>If someone else wins</strong>
            {' '}
            - The wallet they used to place the highest bid will receive the collectible. All proceeds minus a 5% platform fee and one-time conversion fee will be transferred to the wallet that you connected to Fragment when
            {' '}
            {' '}
            <a href="#listing-your-username-on-fragment">listing</a>
            {' '}
            your username.
          </li>
          <li>
            {' '}
            <strong>If you win the auction</strong>
            {' '}
            - You will
            {' '}
            {' '}
            <strong>own the collectible</strong>
            , the wallet you used to place the highest bid will receive it. You will also get your winning bid back, minus a 5%
            {' '}
            {' '}
            <a href="#">platform fee</a>
            {' '}
            and one-time
            {' '}
            {' '}
            <a href="#q-what-39s-the-conversion-fee">conversion fee</a>
            .
          </li>
        </ul>
        <p>
          The username will
          {' '}
          <strong>continue</strong>
          {' '}
          to link to the same chat until it is reassigned. Outdated apps may not display it in the info panel – make sure to always update your app to the latest version.
        </p>
        <h2>
          <a className="anchor-link" href="#faq"><i className="anchor-icon" /></a>
          <a className="anchor" name="faq" />
          FAQ
        </h2>
        <p>This is a list of frequently asked questions on Fragment and Telegram collectibles.</p>
        <h4>
          <a className="anchor-link" href="#q-i-deposited-some-money-but-my-wallet-is-empty-what-happened"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-i-deposited-some-money-but-my-wallet-is-empty-what-happened" />
          Q: I deposited some money but my wallet is empty, what happened?
        </h4>
        <p>Not to worry, this is likely due to one of the following reasons:</p>
        <ul>
          <li>You did not wait long enough – most transactions take a few seconds, but some might take 30 minutes or more.</li>
          <li>
            You are looking in the wrong place, funds will not appear directly on Fragment, they're only visible in your
            {' '}
            <strong>TON wallet</strong>
            .
          </li>
          <li>You have selected the wrong wallet within your wallet app. On some wallets, one “account” can contain several wallets (ie., wallet versions); to fix this, open your wallet settings and look for “Versions”, “Wallets” or similar labels, then rotate through them until you find the one with your funds.</li>
          <li>Your transaction didn't go through – check with your bank or credit card, as some may deny unusual purchases automatically.</li>
        </ul>
        <h4>
          <a className="anchor-link" href="#q-are-there-any-transaction-fees"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-are-there-any-transaction-fees" />
          Q: Are there any transaction fees?
        </h4>
        <p>
          Collectibles are subject to a
          {' '}
          <strong>5% platform fee</strong>
          {' '}
          on each sale (direct sales and the highest bid when an auction ends). Transactions may also be subject to small
          {' '}
          <strong>blockchain fees</strong>
          {' '}
          (~1 Toncoin) that are outside Fragment's control.
        </p>
        <h4>
          <a className="anchor-link" href="#q-i-lost-my-wallet-can-fragment-recover-it"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-i-lost-my-wallet-can-fragment-recover-it" />
          Q: I lost my wallet, can Fragment recover it?
        </h4>
        <p>Fragment is not able to restore wallets as it never stores or comes into contact with private credentials. Wallets are strictly private and it is the responsibility of the owner to ensure that the recovery keys are properly stored.</p>
        <h4>
          <a className="anchor-link" href="#q-how-can-i-log-in-to-fragment-with-a-different-telegram-account"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-how-can-i-log-in-to-fragment-with-a-different-telegram-account" />
          Q: How can I log in to Fragment with a different Telegram account?
        </h4>
        <p>To fully disconnect your Telegram account from Fragment and log in with another phone number, simply open your Telegram app and navigate to:</p>
        <ul>
          <li>
            {' '}
            <strong>Android</strong>
            :
            {' '}
            {' '}
            <em>Settings</em>
            {' '}
            &gt;
            {' '}
            {' '}
            <em>Privacy &amp; Security</em>
            {' '}
            &gt;
            {' '}
            {' '}
            <em>Bots and websites</em>
            {' '}
            &gt;
            {' '}
            {' '}
            <em>Logged in with Telegram</em>
            {' '}
          </li>
          <li>
            {' '}
            <strong>iOS</strong>
            :
            {' '}
            {' '}
            <em>Settings</em>
            {' '}
            &gt;
            {' '}
            {' '}
            <em>Privacy &amp; Security</em>
            {' '}
            &gt;
            {' '}
            {' '}
            <em>Active Websites</em>
            {' '}
            &gt;
            {' '}
            {' '}
            <em>Logged in with Telegram</em>
            {' '}
          </li>
        </ul>
        <p>
          Once there, remove your Fragment session and reopen the website to
          {' '}
          <a href="#connecting-to-fragment-and-telegram">connect</a>
          {' '}
          a different Telegram account.
        </p>
        <h3>
          <a className="anchor-link" href="#telegram-ads"><i className="anchor-icon" /></a>
          <a className="anchor" name="telegram-ads" />
          Telegram Ads
        </h3>
        <h4>
          <a className="anchor-link" href="#q-why-am-i-unable-to-purchase-ads"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-why-am-i-unable-to-purchase-ads" />
          Q: Why am I unable to purchase Ads?
        </h4>
        <p>Users from certain countries may currently be restricted from purchasing Ads on Telegram, as per Telegram's policies. Fragment only facilitates the purchase of Telegram Ads and cannot modify the list of supported countries.</p>
        <h4>
          <a className="anchor-link" href="#q-where-can-i-set-up-the-ads-i-purchased"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-where-can-i-set-up-the-ads-i-purchased" />
          Q: Where can I set up the Ads I purchased?
        </h4>
        <p>
          Fragment only facilitates the purchase of Telegram Ads – to access all Ad settings and create Sponsored Messages (Telegram Ads), you need to log in to Telegram’s official
          {' '}
          <a href="https://ads.telegram.org/">Ad Platform</a>
          .
        </p>
        <h4>
          <a className="anchor-link" href="#q-why-am-i-unable-to-purchase-telegram-premium"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-why-am-i-unable-to-purchase-telegram-premium" />
          Q: Why am I unable to purchase Telegram Premium?
        </h4>
        <p>Users from certain countries may currently be restricted from purchasing Telegram Premium on Fragment, either for their account or for someone else, as per Telegram's policies. Fragment only facilitates the purchase of Telegram Premium and cannot modify the list of supported countries.</p>
        <h4>
          <a className="anchor-link" href="#q-i-purchased-telegram-premium-for-the-wrong-account-can-you-tra"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-i-purchased-telegram-premium-for-the-wrong-account-can-you-tra" />
          Q: I purchased Telegram Premium for the wrong account, can you transfer it?
        </h4>
        <p>Unfortunately, all purchases on Fragment are final, and we are not able to make any changes, asset transfers or refunds after the transaction has been successfully registered on the blockchain.</p>
        <h4>
          <a className="anchor-link" href="#q-why-is-my-premium-subscription-not-showing-up-on-telegram"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-why-is-my-premium-subscription-not-showing-up-on-telegram" />
          Q: Why is my Premium subscription not showing up on Telegram?
        </h4>
        <p>After purchasing a subscription for your account on Fragment, it may take several minutes for it to appear in your Telegram app. If 30 minutes have passed and you still don’t see it, please contact Telegram’s in-app support by opening your Telegram settings and tapping on “Ask a Question”.</p>
        <h3>
          <a className="anchor-link" href="#anonymous-numbers"><i className="anchor-icon" /></a>
          <a className="anchor" name="anonymous-numbers" />
          Anonymous Numbers
        </h3>
        <h4>
          <a className="anchor-link" href="#q-can-i-buy-an-anonymous-number-directly-from-telegram"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-can-i-buy-an-anonymous-number-directly-from-telegram" />
          Q: Can I buy an anonymous number directly from Telegram?
        </h4>
        <p>No, you can only buy existing numbers that other users are willing to sell.</p>
        <h4>
          <a className="anchor-link" href="#q-can-i-use-anonymous-numbers-to-receive-sms-and-phone-calls"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-can-i-use-anonymous-numbers-to-receive-sms-and-phone-calls" />
          Q: Can I use anonymous numbers to receive SMS and phone calls?
        </h4>
        <p>No, anonymous numbers work only on Telegram, they cannot receive regular SMS or phone calls.</p>
        <h4>
          <a className="anchor-link" href="#q-can-i-use-anonymous-numbers-to-sign-up-to-other-platforms"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-can-i-use-anonymous-numbers-to-sign-up-to-other-platforms" />
          Q: Can I use anonymous numbers to sign up to other platforms?
        </h4>
        <p>No, anonymous numbers can only be used to sign up and log in to Telegram.</p>
        <h4>
          <a className="anchor-link" href="#q-can-an-existing-telegram-account-change-its-connected-phone-nu"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-can-an-existing-telegram-account-change-its-connected-phone-nu" />
          Q: Can an existing Telegram account change its connected phone number to an Anonymous Number?
        </h4>
        <p>
          Yes, any existing Telegram account can
          {' '}
          <a href="https://telegram.org/faq#q-how-do-i-change-my-phone-number">change its number</a>
          {' '}
          to any anonymous number that is not already connected to a Telegram account. Anonymous numbers can also be used to
          {' '}
          <strong>create a new account</strong>
          {' '}
          without a SIM card.
        </p>
        <h3>
          <a className="anchor-link" href="#collectible-usernames"><i className="anchor-icon" /></a>
          <a className="anchor" name="collectible-usernames" />
          Collectible Usernames
        </h3>
        <h4>
          <a className="anchor-link" href="#q-why-is-the-collectible-username-i-want-marked-as-unavailable"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-why-is-the-collectible-username-i-want-marked-as-unavailable" />
          Q: Why is the collectible username I want marked as unavailable?
        </h4>
        <p>Some collectibles may be reserved and will become available at a later date. Others could have been bought before you. </p>
        <p>
          Basic Telegram usernames that are currently in use are marked as
          {' '}
          <em>taken</em>
          . Fragment lets you make anonymous offers to the username owner, who can choose to
          {' '}
          <a href="#auctioning-basic-usernames">make it available for purchase</a>
          {' '}
          at any time.
        </p>
        <h4>
          <a className="anchor-link" href="#q-can-i-assign-my-collectible-username-to-a-bot"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-can-i-assign-my-collectible-username-to-a-bot" />
          Q: Can I assign my collectible username to a bot?
        </h4>
        <p>
          You can upgrade your collectible username to assign it to a
          {' '}
          <strong>Telegram bot</strong>
          . To upgrade, assign the username to a bot on Fragment like you would for any other account and pay the one-time fee when prompted.
        </p>
        <h4>
          <a className="anchor-link" href="#q-can-i-assign-my-upgraded-username-to-a-different-bot"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-can-i-assign-my-upgraded-username-to-a-different-bot" />
          Q: Can I assign my upgraded username to a different bot?
        </h4>
        <p>
          Yes, upgrading a collectible username is
          {' '}
          <strong>permanent</strong>
          . You can freely trade your upgraded collectible or assign it to a different bot – it will never lose its upgraded status even if it changes owners.
        </p>
        <h3>
          <a className="anchor-link" href="#basic-usernames"><i className="anchor-icon" /></a>
          <a className="anchor" name="basic-usernames" />
          Basic Usernames
        </h3>
        <h4>
          <a className="anchor-link" href="#q-i-own-a-basic-telegram-username-but-cannot-put-it-up-for-aucti"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-i-own-a-basic-telegram-username-but-cannot-put-it-up-for-aucti" />
          Q: I own a basic Telegram username but cannot put it up for auction, why?
        </h4>
        <p>
          When Telegram
          {' '}
          <strong>denies</strong>
          {' '}
          Fragment's request to auction a basic username, it is likely due to one of the following reasons:
        </p>
        <ul>
          <li>
            You did not set up a
            {' '}
            <a href="https://t.me/TelegramTips/67">2FA password</a>
            {' '}
            on your Telegram account, or you set it up too recently.
          </li>
          <li>You haven't owned that username for a sufficiently long period of time.</li>
          <li>The username has been recently moved (e.g. from your account to one of your channels, etc.).</li>
          <li>Telegram has other reasons to believe you might be acting in bad faith.</li>
        </ul>
        <h4>
          <a className="anchor-link" href="#q-i-put-my-basic-username-up-for-auction-but-i-changed-my-mind-c"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-i-put-my-basic-username-up-for-auction-but-i-changed-my-mind-c" />
          Q: I put my basic username up for auction but I changed my mind, can I take it back?
        </h4>
        <p>
          You can
          {' '}
          <a href="#canceling-an-auction">cancel</a>
          {' '}
          the auction
          {' '}
          <strong>before the first bid is placed</strong>
          . After the first bid, the auction starts and cannot be canceled.
        </p>
        <p>
          Likewise, the conversion of a basic username into a collectible is
          {' '}
          <strong>permanent</strong>
          {' '}
          and cannot be reversed after the first bid is placed.
        </p>
        <h4>
          <a className="anchor-link" href="#q-i-auctioned-my-basic-username-and-nobody-bid-on-it-why-wasn-39"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-i-auctioned-my-basic-username-and-nobody-bid-on-it-why-wasn-39" />
          Q: I auctioned my basic username and nobody bid on it, why wasn't it assigned to me?
        </h4>
        <p>
          The collectible was assigned to the wallet that placed the highest bid during the auction. This
          {' '}
          <strong>can be different</strong>
          {' '}
          from the wallet you connected to Fragment. If nobody else participated in the auction, you will find the collectible in the wallet you had connected to Fragment when the username was first made available for auction.
        </p>
        <h4>
          <a className="anchor-link" href="#q-what-39s-the-conversion-fee"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-what-39s-the-conversion-fee" />
          Q: What's the conversion fee?
        </h4>
        <p>
          Owners of basic usernames can
          {' '}
          <a href="#auctioning-basic-usernames">auction them</a>
          {' '}
          on Fragment –
          {' '}
          <strong>converting the usernames</strong>
          {' '}
          into collectibles. A flat
          {' '}
          <strong>conversion fee</strong>
          {' '}
          of
          {' '}
          <strong>5</strong>
          {' '}
          Toncoins is deducted from the proceeds of this initial auction.
        </p>
        <blockquote>
          <p>
            This fee is collected
            {' '}
            <strong>only once</strong>
            . All future sales for a collectible are only subject to the
            {' '}
            <a href="#q-are-there-any-transaction-fees">5% platform fee</a>
            {' '}
            and necessary blockchain fees.
          </p>
        </blockquote>
        <h3>
          <a className="anchor-link" href="#anonymous-offers-for-basic-usernames"><i className="anchor-icon" /></a>
          <a className="anchor" name="anonymous-offers-for-basic-usernames" />
          Anonymous Offers for Basic Usernames
        </h3>
        <h4>
          <a className="anchor-link" href="#q-can-i-suggest-someone-to-sell-their-username-on-fragment"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-can-i-suggest-someone-to-sell-their-username-on-fragment" />
          Q: Can I suggest someone to sell their username on Fragment?
        </h4>
        <p>
          Fragment allows users to make offers for basic Telegram usernames in exchange for a small fee – all offers are forwarded
          {' '}
          <strong>anonymously</strong>
          {' '}
          from buyer to seller and neither party is made aware of any identifying information (e.g., Telegram id, username, etc.).
        </p>
        <blockquote>
          <p>Note that everyone will see which TON wallet made the offer.</p>
        </blockquote>
        <h4>
          <a className="anchor-link" href="#q-i-made-an-offer-for-a-username-marked-as-taken-what-happens-no"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-i-made-an-offer-for-a-username-marked-as-taken-what-happens-no" />
          Q: I made an offer for a username marked as
          {' '}
          {' '}
          <em>’Taken’</em>
          . What happens now?
        </h4>
        <p>
          Making an offer for a username marked as
          {' '}
          <em>’Taken’</em>
          {' '}
          requires a small non-refundable fee to show that your offer is serious and not meant to bother the username owner. The amount you enter in ‘How much would you pay?’ is
          {' '}
          <strong>not binding</strong>
          {' '}
          and you will not be obligated to pay that price if the name becomes available for auction.
        </p>
        <p>
          Following your offer, the owner can make the name available for purchase on Fragment via a
          {' '}
          <a href="#auctioning-basic-usernames">public auction</a>
          {' '}
          – they are free to choose any
          {' '}
          <strong>minimum bid</strong>
          . Anyone will be able to bid for the username, and you are free to participate in the auction to acquire the name.
        </p>
        <h4>
          <a className="anchor-link" href="#q-will-i-be-notified-if-the-username-becomes-available-for-aucti"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-will-i-be-notified-if-the-username-becomes-available-for-aucti" />
          Q: Will I be notified if the username becomes available for auction?
        </h4>
        <p>
          If you were
          {' '}
          <a href="/about#connecting-to-fragment-and-telegram">logged in with your Telegram account</a>
          {' '}
          on Fragment when you made your offer, you will be automatically subscribed to updates about the username.
        </p>
        <p>
          If you were not logged in, you can always
          {' '}
          <a href="/about#connecting-to-fragment-and-telegram">log in</a>
          , open the page of the desired username and tap
          {' '}
          <strong>'Subscribe to updates'</strong>
          .
        </p>
        <h3>
          <a className="anchor-link" href="#auctions-and-sales-of-collectibles"><i className="anchor-icon" /></a>
          <a className="anchor" name="auctions-and-sales-of-collectibles" />
          Auctions and Sales of Collectibles
        </h3>
        <h4>
          <a className="anchor-link" href="#q-i-won-an-auction-how-do-i-use-my-new-collectible"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-i-won-an-auction-how-do-i-use-my-new-collectible" />
          Q: I won an auction, how do I use my new collectible?
        </h4>
        <p>
          Tap on
          {' '}
          <a href="/my/assets">My Assets</a>
          {' '}
          to see all your collectibles – you can freely sell them, put them up for auction or
          {' '}
          <a href="#assigning-collectible-usernames-to-telegram">use them on Telegram</a>
          .
        </p>
        <h4>
          <a className="anchor-link" href="#q-can-i-transfer-my-collectible-to-someone"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-can-i-transfer-my-collectible-to-someone" />
          Q: Can I transfer my collectible to someone?
        </h4>
        <p>
          Fragment hosts
          {' '}
          <a href="#putting-collectibles-up-for-auction">open sales and auctions</a>
          {' '}
          of collectibles, but any owner can transfer a collectible to someone else
          {' '}
          <strong>for free</strong>
          {' '}
          via the TON blockchain. For example, the 'NFT' tab in
          {' '}
          <strong>Tonkeeper</strong>
          {' '}
          allows you to transfer collectibles to another address, and the same functionality is available in several other TON wallets.
        </p>
        <h4>
          <a className="anchor-link" href="#q-i-won-an-auction-but-can-39t-see-the-collectible-in-my-assets"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-i-won-an-auction-but-can-39t-see-the-collectible-in-my-assets" />
          Q: I won an auction but can't see the collectible in my assets. What happened?
        </h4>
        <p>This technology relies on a distributed network, transactions can take some time. Most transactions will only take seconds, but please allow up to 30 minutes for your collectibles to appear.</p>
        <h4>
          <a className="anchor-link" href="#q-i-assigned-a-collectible-but-can-39t-see-it-on-telegram-why"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-i-assigned-a-collectible-but-can-39t-see-it-on-telegram-why" />
          Q: I assigned a collectible but can't see it on Telegram, why?
        </h4>
        <p>This is likely due to one of the following reasons:</p>
        <ul>
          <li>
            You did not
            {' '}
            <a href="#activating-your-collectible-on-telegram">enable the collectible</a>
            {' '}
            on Telegram – this
            {' '}
            <strong>is not</strong>
            {' '}
            the same as assigning it on Fragment, it's a separate step.
          </li>
          <li>
            You are using an outdated client that doesn't support collectibles - please
            {' '}
            <strong>update</strong>
            {' '}
            your app to version
            {' '}
            <strong>9.1</strong>
            {' '}
            or above.
          </li>
          <li>
            You are looking at a cached or outdated menu, please try fully
            {' '}
            <strong>closing</strong>
            {' '}
            and
            {' '}
            <strong>reopening</strong>
            {' '}
            your app.
          </li>
        </ul>
        <h4>
          <a className="anchor-link" href="#q-will-i-lose-my-collectibles-if-i-lose-my-phone-account-session"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-will-i-lose-my-collectibles-if-i-lose-my-phone-account-session" />
          Q: Will I lose my collectibles if I lose my phone/account/session/phone number?
        </h4>
        <p>
          {' '}
          <strong>No</strong>
          , as long as you safely store the backup credentials (i.e. word list) of your TON wallet, your collectibles will
          {' '}
          {' '}
          <strong>always be safe</strong>
          {' '}
          and you can reassign them to a new Telegram account at any time. This is also true for any platform supporting the collectibles.
        </p>
        <h4>
          <a className="anchor-link" href="#q-are-my-collectibles-tied-to-any-specific-platform"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-are-my-collectibles-tied-to-any-specific-platform" />
          Q: Are my collectibles tied to any specific platform?
        </h4>
        <p>
          {' '}
          <strong>No</strong>
          , as long as you safely store the backup credentials (i.e. word list) of your TON wallet, your collectibles will
          {' '}
          {' '}
          <strong>always be safe</strong>
          {' '}
          regardless of which platform you use them on.
        </p>
        <h4>
          <a className="anchor-link" href="#q-can-i-integrate-collectibles-into-my-own-platform"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-can-i-integrate-collectibles-into-my-own-platform" />
          Q: Can I integrate collectibles into my own platform?
        </h4>
        <p>
          {' '}
          <strong>Yes</strong>
          , the TON blockchain is publicly accessible and anyone is free to reference collectibles or use them within their own platform.
        </p>
        <h4>
          <a className="anchor-link" href="#q-i-bought-a-collectible-but-now-i-39d-like-to-buy-a-better-one"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-i-bought-a-collectible-but-now-i-39d-like-to-buy-a-better-one" />
          Q: I bought a collectible but now I'd like to buy a better one, can Fragment replace it?
        </h4>
        <p>All purchases are final since ownership is permanently fixed in the blockchain, however, nothing prevents buyers from purchasing multiple collectibles.</p>
        <h4>
          <a className="anchor-link" href="#q-what-happens-if-somebody-places-a-higher-bid-than-me"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-what-happens-if-somebody-places-a-higher-bid-than-me" />
          Q: What happens if somebody places a higher bid than me?
        </h4>
        <p>If somebody places a higher bid your Toncoins will be refunded automatically. Funds will normally reappear in your wallet within a few seconds, but this may sometimes take longer due to the nature of the blockchain network.</p>
        <h4>
          <a className="anchor-link" href="#q-i-have-the-highest-bid-in-an-active-auction-but-would-like-to"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-i-have-the-highest-bid-in-an-active-auction-but-would-like-to" />
          Q: I have the highest bid in an active auction but would like to place an even higher bid. Will I lose my funds?
        </h4>
        <p>
          {' '}
          <strong>No,</strong>
          {' '}
          any time someone (including yourself) outbids you, your previous bid will be refunded immediately.
          {' '}
        </p>
        <h4>
          <a className="anchor-link" href="#q-i-sold-my-collectible-but-i-want-it-back-can-fragment-revert-t"><i className="anchor-icon" /></a>
          <a className="anchor" name="q-i-sold-my-collectible-but-i-want-it-back-can-fragment-revert-t" />
          Q: I sold my collectible but I want it back. Can Fragment revert the transaction?
        </h4>
        <p>Transactions are permanent – this secures your entities but also means that once a purchase is finalized it cannot be undone. Of course, you are free to buy back the collectible from its new owner, if they agree.</p>
      </div>
    </div>
  );
}

export default About;
